import { Observable, of } from 'rxjs';
import { IdentityRepository, IdentityUser, Menu } from '@model/identity';

/**
 * Mock implementation of IdentityRepository for testing
 */
export class IdentityRepositoryImplMock extends IdentityRepository {
  /**
   * Mock method that returns a mock identity user
   */
  override getUserInfo(): Observable<IdentityUser> {
    const mockUser: IdentityUser = {
      userName: 'mock-user',
      fullName: 'Mock User',
      lastAccess: new Date().toISOString(),
      fullUrlLogout: '/logout'
    } as IdentityUser;

    return of(mockUser);
  }

  /**
   * Mock method that returns an empty menu array
   */
  override getUserMenu(): Promise<Menu[]> {
    return Promise.resolve([]);
  }

  /**
   * Mock method for fullLogout
   */
  override fullLogout(): void {
    // Mock implementation
  }

  /**
   * Mock method for clearLocalSession
   */
  override clearLocalSession(): void {
    // Mock implementation
  }
}
